export const audits = {
  title: '操作日志',
  titles: {
    list: '操作日志',
  },
  fields: {
    createdAt: '时间',
    timeAndUser: '时间/人',
    entityType: '数据表',
    entityTypeShort: '数据表',
    entityMeta: '表/操作/ID',
    action: '操作',
    actionShort: '操作',
    entityId: '记录ID',
    userName: '操作人',
    ipAddress: 'IP',
    description: '描述',
    changeDetail: '摘要/上下文',
    changeContent: '修改内容',
    relatedCodes: '相关单号',
    contextLabels: {
      donHang: '订单',
      hoaDon: '发票',
      traHang: '退货',
      khachHang: '客户',
      hang: '品名',
      sp: '货号',
      nhom: '分组',
      ncc: '供应商',
      bangGia: '价目',
      pk: '库存',
      pn: '收货',
      ycx: '开票',
      sc: '维修',
      pt: '收款',
      pc: '付款',
      tkq: '账户',
    },
    beforeChange: '修改前',
    afterChange: '修改后',
    requestInfo: '操作来源',
    duAn: '项目',
    chiNhanh: '分店',
    nguon: '来源',
    maThietBi: '设备 ID',
    ungDung: '应用',
    manHinh: '页面',
    tenApi: '操作',
    hamXuLy: '处理函数',
    device: '设备',
    api: 'API',
  },
  nguon: {
    WEB: '网页',
    MOBILE: '手机 App',
    API: '直接调用 API',
  },
  filter: {
    placeholder: '搜索描述、单号、ID…',
    advancedFilter: '高级筛选',
    search: '搜索',
    ma: '单号（订单/发票/货号）',
    maPlaceholder: '订单号、发票号、货号…',
    entityType: '数据表',
    entityId: '记录ID',
    userId: '用户ID',
    user: '用户',
    action: '操作',
    chiNhanh: '分店',
    phamVi: '范围',
    phamViHienTai: '当前项目',
    phamViTatCa: '全部项目',
    duAn: '项目',
    nhomHanhDong: '操作分组',
    nhomHanhDongOptions: {
      taiKhoan: '账户（登录、密码…）',
      nghiepVu: '业务（数据操作）',
    },
    ipAddress: 'IP 地址',
    ipAddressPlaceholder: '例如：113.161',
    thietBi: '设备 / 浏览器',
    thietBiPlaceholder: '例如：iPhone、Samsung、Chrome、设备 ID',
    duongDan: 'API（路径 / 名称）',
    duongDanPlaceholder: '例如：/dat-hang、创建发票',
    phuongThuc: '请求方法',
    nguonThaoTac: '操作来源',
    nguon: '来源',
    manHinh: '页面 / 屏幕',
    manHinhPlaceholder: '例如：/admin/hoa-don、DonHangChiTiet',
    sortFields: {
      ngayTao: '时间',
      entityType: '数据表',
      entityId: '记录ID',
      userId: '操作人',
      action: '操作',
      id: '日志ID',
    },
    fromDate: '开始时间',
    toDate: '结束时间',
    all: '全部',
    clearFilter: '清空筛选',
    apply: '查询',
    clear: '清空',
  },
  messages: {
    noData: '暂无日志数据',
    totalLogs: '总计: {total} 条日志',
    emptyValue: '空',
    noChangeDetail: '未记录字段级变更',
    moreChanges: '另有 {count} 项变更',
    fieldChangeCount: '{count} 个字段已变更',
  },
  export: {
    button: '导出',
    fileName: '操作日志_{date}.xlsx',
    sheetName: '操作日志',
    success: '导出 Excel 成功',
    failed: '导出失败',
    loading: '导出中...',
  },
  entityTypes: {
    DMHangHoaChiNhanh: '分店商品',
    DMHangHoa: '商品',
    DMSanPham: '产品',
    DMNhomSanPham: '产品分组',
    DMNhomHang: '商品分组',
    DMDonViTinh: '单位',
    DMNhaCungCap: '供应商',
    DMKhachHang: '客户',
    DMNhomKhachHang: '客户分组',
    DMDiaChiNhanHang: '收货地址',
    DMThongTinXuatHoaDon: '开票信息',
    DMDoiTacGiaoHang: '配送伙伴',
    DMNhomDoiTacGiaoHang: '配送伙伴分组',
    DMDichVuGiaoHang: '配送服务',
    HTTichHopNhaVanChuyen: '承运商对接',
    DMBangGia: '价目表',
    HTCaiDatBanHang: '销售设置',
    PKCH: '分店库存单',
    PKCT: '库存单明细',
    PNhanHPhieuNhanHang: '收货单',
    DHHoaDon: '发票',
    DHDonHang: '订单',
    DHPhieuTraHang: '退货单',
    SCYeuCauSuaChua: '维修申请',
    HTNguoiDung: '用户',
    SQuyPhieuThu: '收款单',
    SQuyPhieuChi: '付款单',
    SQuyTaiKhoanQuy: '资金账户',
    DHYeuCauXuatHoaDon: '开票申请',
    HTMauIn: '打印模板',
    CNGiaoDich: '应收交易',
    CNChotCongNo: '应收结账',
  },
  actions: {
    CREATE: '新建',
    UPDATE: '更新',
    DELETE: '删除',
    STATUS_CHANGE: '状态变更',
    CREATE_PHIEU_THU: '创建收款单',
    UPDATE_PHIEU_THU: '更新收款单',
    SUBMIT_FOR_APPROVAL: '提交审批',
    APPROVE_PHIEU_THU: '审批收款单',
    REJECT_PHIEU_THU: '拒绝收款单',
    CANCEL_PHIEU_THU: '取消收款单',
    DELETE_PHIEU_THU: '删除收款单草稿',
    CREATE_PHIEU_CHI: '创建付款单',
    UPDATE_PHIEU_CHI: '更新付款单',
    APPROVE_PHIEU_CHI: '审批付款单',
    REJECT_PHIEU_CHI: '拒绝付款单',
    CANCEL_PHIEU_CHI: '取消付款单',
    DELETE_PHIEU_CHI: '删除付款单草稿',
    CREATE_TAI_KHOAN_QUY: '创建资金账户',
    UPDATE_TAI_KHOAN_QUY: '更新资金账户',
    ACTIVATE_TAI_KHOAN_QUY: '启用资金账户',
    DEACTIVATE_TAI_KHOAN_QUY: '停用资金账户',
    DELETE_TAI_KHOAN_QUY: '删除资金账户',
    CREATE_YCX: '创建开票申请',
    GUI_KT: '发给会计',
    GUI_KHACH: '发给客户',
    KHACH_DONG_Y: '客户同意',
    KHACH_KHONG_DONG_Y: '客户不同意',
    HOAN_THANH: '完成',
    HUY: '取消申请',
    DANG_NHAP: '登录',
    DANG_NHAP_THAT_BAI: '登录失败',
    DANG_XUAT: '退出登录',
    DOI_CHI_NHANH: '切换分店',
    DOI_MAT_KHAU: '修改密码',
    CAP_NHAT_HO_SO: '更新资料',
  },
}
